import {Box, useRadio} from "@chakra-ui/react";

function RadioCard(props) {
    const {getInputProps, getCheckboxProps} = useRadio(props)

    const input = getInputProps()
    const checkbox = getCheckboxProps()

    return (
        <Box as="label">
            <input {...input} />
            <Box
                {...checkbox}
                cursor="pointer"
                borderWidth="1px"
                borderRadius="md"
                boxShadow="md"
                _checked={{
                    bg: "#4273a2",
                    color: "white",
                    borderColor: "#4273a2"
                }}
                _focus={{
                    boxShadow: "outline",
                }}
                px={3}
                py={3}
            >
                {props.children}
            </Box>
        </Box>
    )
}

export default RadioCard;
